<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">{{divName}}</span>
      </caption>
      <colgroup>
        <col width="200px"/>
        <col width="75px" />
      </colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <th rowspan="2">{{divName}}</th>
          <th rowspan="2">대상자수</th>
          <th colspan="4">일반소식</th>
          <th colspan="4">반복소식</th>
          <th colspan="12">맞춤소식 전송건수</th>
        </tr>
        <tr>
          <th>전송</th>
          <th>수신자</th>
          <th>확인</th>
          <th>확인자</th>
          <th>전송</th>
          <th>수신자</th>
          <th>확인</th>
          <th>확인자</th>
          <th>생일</th>
          <th>경고</th>
          <th>신규5</th>
          <th>부정키워드</th>
          <th>기억30</th>
          <th>두뇌7</th>
          <th>체조7</th>
          <th>스피커2</th>
          <th>스피커4</th>
          <th>스피커7</th>
          <th>스피커15</th>
          <th>스피커30</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <Row
        :item="rowData.item"
        :rcpCount="rowData.rcpCount"
        :newsNormal="rowData[`${listKey}NewsNormal`]"
        :newsRepeat="rowData[`${listKey}NewsRepeat`]"
        :newsCustom="rowData[`${listKey}NewsCustom`]"
      />
    </template>
  </PlainTable>
</template>

<script>
import Row from "./ItemTable.row";

export default {
  components: { Row },
  props: {
    itemArray: Array,
    listKey: String,
    divName: String
  }
};
</script>